import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { EmailTemplateManager } from "@/features/admin/components/email-template-manager";
import { PageContainer } from "@fleet/ui";

function AdminEmailPage() {
  return (
    <PageContainer maxWidth="6xl">
      <EmailTemplateManager />
    </PageContainer>
  );
}

interface AdminEmailSearch {
  new?: boolean;
  edit?: string;
}

export const adminEmailRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/email",
  // Addressable template editor: `?new=1` to create, `?edit=<id>` to
  // edit specific template. `edit` takes precedence if both present.
  validateSearch: (search: Record<string, unknown>): AdminEmailSearch => {
    const edit = typeof search.edit === "string" && search.edit !== "" ? search.edit : undefined;
    if (edit) {
      return { edit };
    }
    const isNew =
      search.new === true || search.new === 1 || search.new === "1" || search.new === "true";
    return isNew ? { new: true } : {};
  },
  component: AdminEmailPage,
});
